import { render, staticRenderFns } from "./ExtratoFornecedor.vue?vue&type=template&id=953b97fe&scoped=true&"
import script from "./ExtratoFornecedor.vue?vue&type=script&lang=js&"
export * from "./ExtratoFornecedor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "953b97fe",
  null
  
)

export default component.exports